module.exports = __webpack_public_path__ + "img/WaterSign_bg.50c4d5d4.jpg";